import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  title: FelaCSS;
  amount: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: colors.space,
    flex: 1,
  },

  title: {
    fontDefault: 14,
    lineHeight: 1,
    flex: 3,
  },

  amount: {
    alignItems: 'flex-end',
    fontDefaultSemiBold: 14,
    lineHeight: 1,
    flex: 2,
  },
});

export default styles;
